// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__TBTyb","content":"RecentSearches_content__1pO66"};